<template>
  <div class="container">
    <el-dialog
      :title="dialogAdd ? '新建产品' : '修改产品'"
      :visible.sync="dialogVisible"
      center
      width="40%"
      @close="dialogClosed">
      <el-form :model="form" label-position="right" :rules="rules" ref="refForm" label-width="130px"
               style="width: 90%;">
        <el-form-item label="产品型号" prop="productName">
          <el-input :disabled="!dialogAdd" v-model.trim="form.productName" autocomplete="off" maxlength="20"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="芯片名称" prop="chipName">
          <el-input :disabled="!dialogAdd" v-model.trim="form.chipName" autocomplete="off" maxlength="20"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="封装形式" prop="packageType">
          <el-select v-model="form.packageType" allow-create filterable default-first-option size="medium"
                     placeholder="请选择">
            <el-option
              v-for="(item, i) in packageNoData"
              :id="item.name"
              :key="i"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="净重(单位g)" prop="netWeight">
          <el-input @mousewheel.native.prevent v-model.trim="form.netWeight"
                    oninput="if(value.length>5)value=value.slice(0,6)" type="number" title='' autocomplete="off"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="毛重(单位g)" prop="grossWeight">
          <el-input @mousewheel.native.prevent v-model.trim="form.grossWeight"
                    oninput="if(value.length>5)value=value.slice(0,6)" type="number" title='' autocomplete="off"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button class="cancelButton" size="small" @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="saveForm(dialogAdd)"
          :loading="loadingForm">
            保存
        </el-button>
      </span>
    </el-dialog>
    <div class="control-container">
      <el-button
        @click="addClick"
        type="warning"
        size="small">
        新建产品
      </el-button>
    </div>
    <div class="target-container">
      <el-table
        v-loading="loadingMain"
        ref="table"
        height="100%"
        border
        :data="prodNoData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">>
        <el-table-column
          prop="productName"
          label="产品型号">
        </el-table-column>
        <el-table-column
          prop="chipName"
          label="芯片名称">
        </el-table-column>
        <el-table-column
          prop="packageType"
          label="封装形式">
        </el-table-column>
        <el-table-column
          label="净重">
          <template slot-scope="scope">
            {{scope.row.netWeight}}g
          </template>
        </el-table-column>
        <el-table-column
          label="毛重">
          <template slot-scope="scope">
            {{scope.row.grossWeight}}g
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editClick(scope.row)" class="link">
              修改
            </el-button>
            <span class="vertical-separator"/>
            <el-button type="text" @click="deleteClick(scope.$index, scope.row.id)" class="link">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
  import {
    productsList,
    createProductPost,
    rmProductDelete,
    updateProductPut,
  } from '@/api/products';
  import {defines} from '@/config';
  import {isNum} from '@/utils';
  import {
    Pagination,
  } from '@/components';

  export default {
    name: 'Product-Manage',
    components: {
      Pagination,
    },
    data() {
      const reg = /^(?!\d+$)[\da-zA-Z]+$/;
      let validateProdNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value.trim() === '';
        if (isEmptyValue) {
          callback(new Error('产品型号不能为空'));
          return;
        }
        callback();
      };
      let validateChipName = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value.trim() === '';
        if (isEmptyValue) {
          callback(new Error('芯片名称不能为空'));
          return;
        }
        if (!reg.test(value)) {
          callback(new Error('芯片名称只能是字母或者字母加数字'));
          return;
        }
        callback();
      };
      let validateNetWeight = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value === '';
        if (isEmptyValue) {
          callback(new Error('净重不能为空'));
          return;
        }
        if (!isNum(value)) {
          callback(new Error('净重必须是数值类型'));
          return;
        }
        if (!(/^(-?\d+)(\.\d{1,5})?$/.test(value))) {
          callback(new Error('净重最多有5位小数'));
          return;
        }
        if (Number.parseFloat(value) <= 0) {
          callback(new Error('净重必须大于0'));
          return;
        }
        callback();
      };
      let validateGrossWeight = (rule, value, callback) => {
        const isEmptyValue = value === undefined || value === '';
        if (isEmptyValue) {
          callback(new Error('毛重不能为空'));
          return;
        }
        if (!isNum(value)) {
          callback(new Error('毛重必须是数值类型'));
          return;
        }
        if (!(/^(-?\d+)(\.\d{1,5})?$/.test(value))) {
          callback(new Error('毛重最多有5位小数'));
          return;
        }
        if (Number.parseFloat(value) <= 0) {
          callback(new Error('毛重必须大于0'));
          return;
        }
        callback();
      };
      return {
        page: 1,
        perpage: 20,
        totalCount: 0,
        loadingMain: true,
        prodNoData: [],
        form: {
          productName: undefined,
          chipName: undefined,
          packageType: undefined,
          netWeight: '',
          grossWeight: '',
        },
        rules: {
          productName: [
            {required: true, validator: validateProdNo, trigger: 'blur'},
          ],
          chipName: [
            {required: true, validator: validateChipName, trigger: 'blur'},
          ],
          packageType: [
            {required: true, message: '封装形式不能为空', trigger: 'blur'},
          ],
          netWeight: [
            {required: true, validator: validateNetWeight, trigger: 'blur'},
          ],
          grossWeight: [
            {required: true, validator: validateGrossWeight, trigger: 'blur'},
          ]
        },
        dialogVisible: false,
        loadingForm: false,
        deleteIndex: undefined,
        deleteChipId: undefined,
        dialogAdd: false,
        updateChipId: undefined,
        packageNoData: defines.packageNo
      };
    },
    mounted() {
      this.productsList(this.page, this.perpage);
    },
    methods: {
      async productsList(page, perpage) {
        try {
          this.loadingMain = true;
          const res = await productsList({
            page: page,
            perpage: perpage
          });
          const data = res.data;
          this.prodNoData = data.records;
          if (data.count !== undefined) {
            this.totalCount = data.count;
          }
        } catch (e) {
        } finally {
          this.loadingMain = false;
        }
      },
      async prodNoListGet(page, perpage) {
        try {
          const res = await productsList({
            page: page,
            perpage: perpage
          });
          const data = res.data;
          const prodNoList = data.records;
          this.$store.commit('saveProdNoList', prodNoList);
        } catch (e) {
        }
      },
      saveForm(addOrEdit) {
        this.$refs.refForm.validate((valid) => {
          if (valid) {
            if (addOrEdit) {
              this.addChip();
            } else {
              this.editChip();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      async addChip() {
        const {
          productName,
          chipName,
          packageType,
          netWeight,
          grossWeight,
        } = this.form;
        try {
          this.loadingForm = true;
          await createProductPost({
            productName,
            chipName,
            packageType,
            netWeight: Number.parseFloat(netWeight),
            grossWeight: Number.parseFloat(grossWeight),
          });
          this.page = 1;
          this.productsList(this.page, this.perpage);
          this.$refs.table.bodyWrapper.scrollTop = 0;
          this.$message({
            type: 'success',
            message: '添加成功'
          });
          this.dialogVisible = false;
        } catch (e) {
        } finally {
          this.loadingForm = false;
        }
      },
      async editChip() {
        const {
          packageType,
          netWeight,
          grossWeight,
        } = this.form;
        try {
          this.loadingForm = true;
          await updateProductPut({
            id: this.updateChipId,
            packageType,
            netWeight: Number.parseFloat(netWeight),
            grossWeight: Number.parseFloat(grossWeight),
          });
          this.productsList(this.page, this.perpage);
          this.dialogVisible = false;
        } catch (e) {
        } finally {
          this.loadingForm = false;
        }
      },
      addClick() {
        this.dialogVisible = true;
        this.dialogAdd = true;
        this.form = {
          productName: undefined,
          chipName: undefined,
          packageType: undefined,
          netWeight: '',
          grossWeight: '',
        };
      },
      editClick(item) {
        const {
          productName,
          chipName,
          packageType,
          netWeight,
          grossWeight,
        } = item;
        this.dialogVisible = true;
        this.dialogAdd = false;
        this.updateChipId = item.id;
        this.form = {
          productName,
          chipName,
          packageType,
          netWeight,
          grossWeight,
        }
      },
      async deleteClick(index, chip_id) {
        this.deleteIndex = index;
        this.deleteChipId = chip_id;
        this.$confirm('此操作将永久删除该产品, 是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteChip();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      async deleteChip() {
        try {
          await rmProductDelete({id: this.deleteChipId});
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.prodNoListGet(1, 200);
          if (this.prodNoData.length === 1 && this.page > 1) {
            this.page = this.page - 1;
          }
          this.productsList(this.page, this.perpage);
        } catch (e) {
        }
      },
      dialogClosed() {
        this.$refs.refForm && this.$refs.refForm.resetFields();
      },
      onChangePage() {
        this.productsList(this.page, this.perpage);
      }
    }
  };
</script>
<style lang="less" scoped>

  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }

  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }

  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 0 20px;
    height: 100%;
    overflow: auto;
  }

  .link {
    color: #169BD5;
    padding: 0 5px;
  }

  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }

  /deep/ .el-table--border th.gutter:last-of-type {
    border-bottom: 0;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }

  .small_label .el-form-item__label {
    font-size: 12px;
  }

</style>
